<template>
  <div id="app">
    <Nav />
    <div class="columns is-full">
      <router-view />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Navbar/Nav";

export default {
  name: "app",
  components: {
    Nav,
  },
  mounted: function() {
    console.log("Skillgames-PassApp-version 0.2, Release date: 2 May 2020");
  },
};
</script>
<style lang="scss">
@import "./assets/scss/main.scss";
</style>
